<template>
  <div class="confirmation">
    <div class="confirmation__container">
      <div class="confirmation__header">
        <div class="confirmation__xmark-icon">
          <FontAwesomeIcon :icon="['far', 'circle-xmark']" />
        </div>

        <h2 class="confirmation__title">
          {{ $t('landingpage.checkout-page.confirmation.failed.title') }}
        </h2>
        <p class="confirmation__intro">
          {{ $t('landingpage.checkout-page.confirmation.failed.intro') }}
        </p>
      </div>

      <div class="confirmation__btn-container">
        <button
          type="button"
          class="confirmation__btn-cancel-registration btn btn-primary"
          @click="emit('new-payment-link-requested')"
        >
          {{
            $t(
              'landingpage.checkout-page.confirmation.btn.get-new-payment-link',
            )
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['new-payment-link-requested'])
</script>
